import * as types from '../actions/types'

const initialState = {
  shipperAvailableCertificates: [],
  shipperAvailableProperty: [],
  incidentData: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_INCIDENT_CATEGORIES: {
      return { ...state, incidentData: { ...payload } }
    }
    case types.FETCH_SHIPPER_AVAILABLE_CERTIFICATES: {
      return { ...state, shipperAvailableCertificates: payload }
    }
    case types.FETCH_SHIPPER_AVAILABLE_PROPERTY: {
      return { ...state, shipperAvailableProperty: payload }
    }
    default:
      return state
  }
}
